import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import MainLayout from "../layout/MainLayout";
import { Ghost } from "lucide-react";
import Particles from "react-tsparticles";

export const NotFound = () => {
  return (
    <MainLayout>
      {/* Custom Particles Background */}
      <Particles
        id="notFoundParticles"
        options={{
          fullScreen: { enable: false },
          background: { color: { value: "transparent" } },
          particles: {
            number: { value: 40 },
            color: { value: "#00bfa6" },
            links: {
              enable: true,
              color: "#00bfa6",
              distance: 120,
              opacity: 0.4,
            },
            move: {
              enable: true,
              speed: 0.6,
              outMode: "bounce",
            },
            size: { value: 2 },
            opacity: { value: 0.3 },
          },
        }}
        className="absolute inset-0 z-0 pointer-events-none"
      />

      {/* Not Found Section */}
      <section className="relative z-10 min-h-[60vh] flex flex-col items-center justify-center text-center px-4">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="p-10 backdrop-blur-xl bg-white/30 dark:bg-white/10 border border-white/20 dark:border-white/10 rounded-2xl shadow-lg max-w-md w-full"
        >
          <div className="flex justify-center mb-5">
            <Ghost className="w-14 h-14 text-red-500" />
          </div>
          <h1 className="text-4xl font-bold mb-3">404 - Not Found</h1>
          <p className="text-gray-700 dark:text-gray-300 mb-6">
            Looks like you wandered off the trail. This page doesn’t exist.
          </p>
          <Link
            to="/"
            className="inline-block px-6 py-2 bg-teal-600 hover:bg-teal-700 text-white font-medium rounded-lg transition"
          >
            Back to Safety
          </Link>
        </motion.div>
      </section>
    </MainLayout>
  );
};
